import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders the Traders, Platforms, and Symbols Aggregated Risk widgets through the new owned grid
 * (`TableModelViewer`, ADR 0014) instead of the ag-grid `ColumnTemplateTableViewer`.
 *
 * The shared Aggregated Risk renderer is used by dashboard widgets and the standalone Risk page,
 * so this one rollout flag controls both placements while remaining independent from Results.
 */
export const enableNewAggregatedRiskGrid = new FeatureFlag({
    key: 'enable-new-aggregated-risk-grid',
    defaultValue: false,
});
